// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyC8oqS89AhloTPuESBKQ6ACtyaNsXIGW7o",
    authDomain: "doggo.podlodowski.it",
    projectId: "doggooo",
    storageBucket: "doggooo.firebasestorage.app",
    messagingSenderId: "1008787318565",
    appId: "1:1008787318565:web:00ad56c0ebca7439c8dccc",
    measurementId: "G-MVF5Q4TM1T"
  },
};

environment.firebase.authDomain = window.location.host;

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
